module.exports = __webpack_public_path__ + "img/5c2048f.svg";